var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.27 22.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#528918;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,7.37a3.72,3.72,0,0,0,.21-1.5c.72-2,3-2.7,4.65-3.18,0-.15-.24-.09-.18-.3C8.94,1.58,13.11-1.06,18.24.47c.3.93,1.29,1.68,1.35,2.52a1.54,1.54,0,0,1,.63,1.68,10.91,10.91,0,0,1-1.38.9,15.61,15.61,0,0,0-5,0c-.9-.9-2.43.33-3.51.15a3.59,3.59,0,0,1-2,.54c0,.24.18.21.09.48C9,7.37,10.5,7.07,10.74,8a2.28,2.28,0,0,1,2,2.31c.12.39.33.12.54.39.15.57.9,1.23,1.2,1.95a6.89,6.89,0,0,1-.12,3C13,19.13,9.12,21,5.7,22.07c-.15,0-.45.09-.36-.18-.66.66-1.89.18-2.88.33a2.75,2.75,0,0,1-.72-1c-.21,0-.09-.36-.27-.39a.42.42,0,0,1,.09-.27c.33-.18-.27-.21-.18-.45.39-.72-.54-2.1.57-2.7,3.21.36,5.58-1.47,7.8-2.52.27-.81,1.14-1,1.32-1.86.09-.3-.27-.27-.27-.54a.59.59,0,0,0-.36-.09c-.9-.51-2.22-.81-3-1.23-.48.27-.87,0-1.56-.12a12.71,12.71,0,0,1-4.44-.87C1.38,10,1.29,9.71.9,9.77A7.52,7.52,0,0,1,.09,8.66C.21,8.09.33,7.76,0,7.37Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSGreen);
export default __webpack_public_path__ + "static/media/s-green.2333029a4f9c77f1f5c742fa43c95b87.svg";
export { ForwardRef as ReactComponent };